<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_55_203)">
      <g clip-path="url(#clip0_55_203)">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="#FAFAFA" />
        <path
          d="M27.078 37.808C29.786 37.808 31.982 35.612 31.982 32.904C31.982 30.196 29.787 28 27.078 28C24.369 28 22.174 30.196 22.174 32.904"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27.083 37.8131C26.345 37.8131 25.646 37.6501 25.018 37.3591L22 38.0001L22.631 34.9761C22.338 34.3461 22.174 33.6441 22.174 32.9041"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.557 28.0281C26.199 27.2071 26 26.3121 26 25.3731C26 21.3561 29.598 18.1331 34 18.1331C38.402 18.1331 42 21.3561 42 25.3731C42 27.7471 40.738 29.8371 38.801 31.1551C38.802 31.9111 38.8 32.9301 38.8 34.0001L35.661 32.4541C35.124 32.5571 34.569 32.6131 34 32.6131C33.293 32.6131 32.607 32.5291 31.953 32.3721"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path d="M52 50H54V48V28C54 15.8497 44.1503 6 32 6C19.8497 6 10 15.8497 10 28C10 40.1503 19.8497 50 32 50H52Z" :stroke="color" stroke-width="4" />
    </g>
    <defs>
      <filter id="filter0_d_55_203" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55_203" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55_203" result="shape" />
      </filter>
      <clipPath id="clip0_55_203">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Icon3',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
  },
};
</script>
